/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyNamedParameterValidationRequest {
    getFixupPrototypeFunction() { return PolicyNamedParameterValidationRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyNamedParameterValidationRequest>): PolicyNamedParameterValidationRequest {
        let obj = Object.assign(new PolicyNamedParameterValidationRequest(), model);
        PolicyNamedParameterValidationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyNamedParameterValidationRequest>): PolicyNamedParameterValidationRequest {
        if (!model) return null;
        return PolicyNamedParameterValidationRequest.newInstance(<PolicyNamedParameterValidationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyNamedParameterValidationRequest) {
        if (!obj) return;

        models.PolicyNamedParameterValidationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyNamedParameterValidationRequest): boolean {
        Object.setPrototypeOf(obj, PolicyNamedParameterValidationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique URI for policy
     */
    policy_uri: string;

    /**
     * Policy execution parameters, encoded as a JSON string
     */
    params: string;

}
